<template>
	<!-- Content -->
	<div :class="{ 'opacity-50': status == 'feedback' }">

		<!-- Question -->
		<div class="m-auto" style="max-width: 700px;">
			<span class="h5" v-html="questionText"></span>
			<hr>
		</div>

		<!-- Checkboxes -->
		<div class="mt-4 mb-0 d-flex flex-wrap">
			<table class="table borderless w-auto m-auto blockquote">
				<tbody>
					<!-- <div v-for="box in boxes" :key="box.index" class="form-check text-start mx-3 my-1"> -->
					<tr v-for="box in boxes" :key="box.index" class="form-check text-start">
						<td style="border: none;">
							<input v-model="box.checked" type="checkbox" role="button"
							:id="box.index" :value="box.index" name="answer" :disabled="lockInput"
							class="form-check-input" style="margin-right: 0.5em;"
							:class="{
								'checkbox-correct': box.styleCorrect,
								'checkbox-incorrect': box.styleIncorrect,
								'checkbox-incomplete': box.styleIncomplete,
								'radiobutton': question.type == 'QT1'
							}"
							@click="updateAnswer">
							<label :for="box.index" role="button"
							class="form-check-label no-select" style=""
							:class="{
								'label-correct': box.styleCorrect,
								'label-incorrect': box.styleIncorrect,
								'label-incomplete': box.styleIncomplete,
							}">
								{{ getAnswerText(box.index) }}
							</label>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- Button and hint area -->
		<div v-if="status != 'feedback'" class="mt-4">
			<div class="m-auto" style="max-width: 700px;">
				<hr>
			</div>

			<!-- Help text -->
			<div class="mb-3">
				<div v-if="status == 'verify'" class="text-muted">
					<span v-if="question.type == 'QT1'">
						{{ $t('quiz_hint_single') }}
					</span>
					<span v-else>
						{{ $t('quiz_hint_multi') }}
					</span>
				</div>
				<div v-if="status == 'try-again'" class="text-danger">
					<span v-if="currentAnswers.length < numberOfAnswers">
						{{ $t('quiz_too_few') }}
					</span>
					<span v-else-if="currentAnswers.length > numberOfAnswers">
						{{ $t('quiz_too_many') }}
					</span>
					<span v-else>
						{{ $t('quiz_try_again') }}
					</span>
				</div>
				<div v-if="status == 'success'" class="text-success">
					<span>
						{{ $t('quiz_correct') }}
					</span>
				</div>
			</div>

			<!-- Answer button -->
			<div v-if="status == 'verify'">
				<button
					class="btn px-5 progress-bar-striped"
					:class="{ 'btn-primary': allowSubmit, 'btn-secondary': !allowSubmit, 'progress-bar-animated': allowSubmit }"
					@click="verify"
					:disabled="!allowSubmit">
					{{ $t('quiz_button_verify') }}
				</button>
			</div>
			<div v-else-if="status == 'try-again'">
				<button
					class="btn px-5 progress-bar-striped progress-bar-animated btn-danger"
					@click="tryAgain">
					{{ $t('quiz_button_try_again') }}
				</button>
			</div>
			<div v-else-if="status == 'success'">
				<button
					class="btn px-5 progress-bar-striped progress-bar-animated btn-success"
					@click="complete">
					{{ $t('continue') }}
				</button>
			</div>
		</div>
	</div>
</template>



<script>
import Timer from '@/components/Timer';

export default {
	props: [ "question", "selectedIndex" ],
	data() {
		return {
			id: null,
			status: null,
			lockInput: false,
			boxes: [],
			answerIds: [],
			numberOfAnswers: 0,

			timer: null,
		};
	},
	methods: {
		load(question) {
			this.id = question.id;
			// question.difficulty
			this.status = 'verify';
			this.lockInput = false;
			this.answerIds = question.answerIds;
			this.numberOfAnswers = 0;

			this.boxes = [];
			for (let i = 0; i < question.answers.length; i++) {

				const isCorrect = question.correct.includes(question.answers[i]);
				if (isCorrect) {
					this.numberOfAnswers++;
				}

				this.boxes.push({
					index: question.answers[i],
					isCorrect,
					checked: false,
					styleCorrect: false,
					styleIncorrect: false,
					styleIncomplete: false,
				});

			}

			if (question.shuffle) {
				this.shuffle(this.boxes);
			}

			// Log new question
			if (!this.$tracker.isTaskComplete(this.id)) {
				const currentOrder = this.boxes.map(box => box.index);
				this.$log.onQuestionStart(this.id, question.mechanic, this.selectedIndex+1, currentOrder, question.correct);
				this.$tracker.onTaskStart(this.id);
			}
			// Auto-complete answers
			else {
				this.verify(null, true);
			}
		},
		verify(event, autoComplete=false) {
			let allCorrect = true;
			const answerCount = this.boxes.filter(box => box.checked).length;
			const tooFew = answerCount < this.numberOfAnswers;
			const tooMany = answerCount > this.numberOfAnswers;

			for (let box of this.boxes) {
				if (autoComplete) {
					box.checked = box.isCorrect;
				}
				else {
					if (!box.checked && tooFew) {
						box.styleIncomplete = true;
					}
					if (box.checked && tooMany) {
						box.styleIncomplete = true;
					}
				}

				if (!tooMany) {
					box.styleCorrect = box.checked && box.isCorrect;
					box.styleIncorrect = box.checked && !box.isCorrect;
				}


				if (box.checked != box.isCorrect) {
					allCorrect = false;
				}
			}

			for (let box of this.boxes) {
			}

			if (autoComplete) {
				this.status = 'feedback';
				this.lockInput = true;
			}
			else {
				this.$log.onQuestionVerify(this.id, this.currentAnswers, allCorrect);
				if (allCorrect) {
					this.status = 'success';
					this.$emit("complete");
					this.$log.onQuestionComplete(this.id);
					this.$tracker.onTaskComplete(this.id, this.timer.elapsed);
					this.lockInput = true;
				}
				else {
					this.status = 'try-again';
					// this.lockInput = true;
					this.$tracker.onTaskMistake();
				}
			}
		},
		complete() {
			this.status = 'feedback';
			this.$emit("progress");
			this.$log.onQuestionNext(this.id);
		},
		tryAgain(reset=true) {
			this.status = 'verify';
			this.lockInput = false;
			this.$log.onQuestionTryAgain(this.id);

			for (let box of this.boxes) {
				if (reset) box.checked = false;
				box.styleCorrect = false;
				box.styleIncorrect = false;
				box.styleIncomplete = false;
			}
		},
		getAnswerText(index) {
			return this.getText(this.answerIds[index-1]);
			// return this.getText(this.boxes[index-1].key);
			// return this.getText(this.id, 'answer_' + index);
		},
		updateAnswer() {
			if (this.question.type == 'QT1') {
				this.boxes.forEach(box => box.checked = false);
			}
		}
	},
	computed: {
		allowSubmit() {
			if (this.question.type == 'QT1') {
				return this.boxes.filter(box => box.checked).length == this.numberOfAnswers;
			}
			else {
				return this.boxes.some(box => box.checked);
			}
		},
		currentAnswers() {
			return this.boxes.filter(box => box.checked).map(box => box.index);
		},
		questionText() {
			let text = this.getText(this.question.id, 'text');
			// text = text.replace('A)', '<div class="d-flex"><span>Assertion</span><hr class="flex-grow-1"></div>');
			if (text.startsWith('A)'))
				text = text.replace('A)', `<div class="separator mb-2"><span>${this.getText('assertion')}</span></div>`);
			else
				text = text.replace('A)', `<div class="separator mt-3 mb-2"><hr><span>${this.getText('assertion')}</span></div>`);
			text = text.replace('R)', `<div class="separator mt-3 mb-2"><hr><span>${this.getText('reason')}</span></div>`);
			return text;
		}
	},
	watch: {
		question(newData) {
			this.load(newData);
		},
		currentAnswers() {
			if (this.status == 'try-again') {
				this.tryAgain(false);
			}
			this.$log.onQuestionChangeAnswer(this.id, this.currentAnswers);
		}
	},
	mounted() {
		this.timer = new Timer();
		this.load(this.question);
	},
	beforeDestroy() {
		if (this.timer) {
			this.timer.clear();
		}
	}
};
</script>



<style scoped>
	.radiobutton {
		border-radius: 100% !important;
	}


	/deep/ .separator {
		display: flex;
		flex-direction: column;
		align-items: center;
		/*margin: .7em 0 .2em 0;*/
		font-size: 0.8em;
		/*font-style: italic;*/
		/*font-weight: 400;*/
	}
	/deep/ .separator span {
		text-decoration: underline;
		color: #546E7A;
	}
	/deep/ .separator hr {
		/*flex-grow: 1;*/
		width: 100%;
		margin: 0 1em 0.5em;
	}
	/deep/ .separator hr:last-child {
		/*flex-grow: 50;*/
	}
</style>
